import styled from 'styled-components';
import { up } from 'styled-breakpoints';
import Filter from '@fenderdigital/ui/Icons/Filter';
import IconError from '@fenderdigital/ui/Icons/IconError';
import { Focus } from '@fenderdigital/ui/utils/css';
import Link from '../../../Link';

export const ResultsContainer = styled.div`
  height: 100%;
  overflow-y: auto;
  padding: 2rem 0.7rem 1rem 1rem;

  ${up('tablet-portrait')} {
    height: calc(100% - 4.938rem);
  }
`;

export const SectionRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  max-width: 23.375rem;
`;

export const MoreResultsButton = styled(Link)`
  width: 100%;
  height: 2.125rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 1.5rem;
  background-color: white;
  border: 1px solid black;

  ${Focus}
`;

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: center;
`;

export const FilterIcon = styled(Filter)`
  fill: #c4c4c4 !important;
  width: 1.1rem;
  height: 1.1rem;
`;

export const ErrorIcon = styled(IconError)`
  width: 5.5625rem;
  height: 5.5625rem;
  fill: #e5e5e5 !important;
`;

